var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@mui/material';
import React from 'react';
import { gradients } from '../ColorPaper';
import { themeColors } from '../JuvareTheme';
/**
 * Absolutely positioned top bar component which contains content that needs to be accessed at all times.
 * Supports gradient background. By default, this component's background is transparent, you have
 * to manipulate it with `isOpaque` prop.
 *
 * @param {object} props - Component props.
 * @param {boolean} [props.isOpaque] - Controls the opacity of the background. If true, background is fully opaque.
 * @param {keyof typeof gradients} [props.gradient] - Optional gradient background key.
 * @param {React.ReactNode} [props.children] - Child content to render inside the top bar.
 * @returns {React.ReactElement} The rendered top bar component.
 */
export const ModalSlideoutTopBar = (_a) => {
    var { isOpaque, gradient, children } = _a, props = __rest(_a, ["isOpaque", "gradient", "children"]);
    return (React.createElement(Box, { sx: [
            {
                height: 'fit-content',
                width: '100%',
                position: 'absolute',
                top: 0,
                right: 0,
                color: (theme) => (gradient ? themeColors.decorative.white : theme.palette.text.primary),
                zIndex: (theme) => theme.zIndex.drawer,
            },
        ], "data-test": props['data-test'] },
        React.createElement(Box, { sx: [
                {
                    bottom: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                    position: 'absolute',
                    opacity: isOpaque ? 1 : 0,
                    transition: (theme) => theme.transitions.create('opacity'),
                },
                gradient ? Object.assign({}, gradients[gradient]) : { background: themeColors.surface.primary },
            ] }),
        children));
};
